import React, { ReactNode } from 'react'
import {
  ConversationRow as ConversationRowData,
  ConversationState,
  ConversationType,
} from '../../../generated/api/chat-conversations'
import { InfiniteScroll } from '../../common/InfiniteScroll'
import { ConversationRow } from './ConversationRow'
import { useConversations } from './useConversations'

interface ConversationsListProps {
  type: ConversationType
  state: ConversationState
  societyIds?: string[]
  onRowClick?: (row: ConversationRowData) => void
  rowClassName?: string
  className?: string
  rootRef?: React.MutableRefObject<HTMLDivElement | null>
  emptyState?: ReactNode
}

export const ConversationsList = ({
  type,
  state,
  societyIds,
  onRowClick,
  rowClassName,
  className,
  rootRef,
  emptyState,
}: ConversationsListProps): React.ReactNode => {
  const { rows, isLoading, isFetchingNextPage, fetchNextPage } =
    useConversations({ type, state, societyIds })

  if (emptyState && !isLoading && rows.length === 0) {
    return <>{emptyState}</>
  }

  return (
    <InfiniteScroll
      key={`conversations-${type}-${state}`}
      className={className}
      onEndReached={fetchNextPage}
      isFetching={isLoading || isFetchingNextPage}
      rootRef={rootRef}
    >
      {rows.map((row) => (
        <ConversationRow
          key={row.id}
          row={row}
          className={rowClassName}
          onClick={onRowClick}
        />
      ))}
    </InfiniteScroll>
  )
}
